<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/sjkd/zbgg">招标公告</router-link>
    </div>

    <div class="container-width mb50">
      <div class="title">
        <span @click="zbcpList()">招标产品公告</span>
        <span class="more" @click="zbcpList()">查看更多 >> </span>
      </div>
      <div>
        <ul class="xx1_lb">
          <li
            @click="gozbArticle(item)"
            v-for="(item, index) in zbData"
            :key="index"
          >
            <a @click="gozbArticle(item)">{{ item.title }}</a>
          </li>
        </ul>
      </div>
      <div class="title">
        <span @click="cplzList()">产品论证公告</span>
        <span @click="cplzList()" class="more">查看更多 >> </span>
      </div>
      <div>
        <ul class="xx1_lb">
          <li
            @click="gocpArticle(item)"
            v-for="(item, index) in cpData"
            :key="index"
          >
            <a @click="gocpArticle(item)">{{ item.title }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import service from "../../../service/index";
import BANNER from "../../../components/banner/sjkd";
export default {
  name: "ZBGGINDEX",
  data() {
    return {
      navigationData: [
        {
          name: "招标公告",
          path: "/sjkd/zbgg",
        },
      ],
      currentPath: "/sjkd/zbgg",
      pageIndex: 1,
      pageSize: window.screen.width < 720 ? 6 : 10,
      zbData: [],
      cpData: [],
    };
  },
  components: { BANNER },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      let parmes = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        isshow: 1,
        type: 1,
      };
      let parmes2 = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        isshow: 1,
        type: 2,
      };
      service.getwzBiddingNoticeList(parmes, (res) => {
        res.content.map((item) => {
          item.releaseDate = item.releaseDate.split(" ")[0];
        });
        this.zbData = res.content || [];
      });
      service.getwzBiddingNoticeList(parmes2, (res) => {
        res.content.map((item) => {
          item.releaseDate = item.releaseDate.split(" ")[0];
        });
        this.cpData = res.content || [];
      });
    },

    gozbArticle(e) {
      this.$router.push({
        path: `/sjkd/zbgg/article/zb`,
        query: {
          id: e.id,
        },
      });
    },
    gocpArticle(e) {
      this.$router.push({
        path: `/sjkd/zbgg/article/cp`,
        query: {
          id: e.id,
        },
      });
    },
    zbcpList() {
      this.$router.push({
        path: `/sjkd/zbgg/list`,
        query: {
          type: "zb",
        },
      });
    },
    cplzList() {
      this.$router.push({
        path: `/sjkd/zbgg/list`,
        query: {
          type: "cp",
        },
      });
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style scoped lang="scss">
.container-width {
  .title {
    margin-top: 50px;
    font-size: 1.2rem;
    background: #00479d;
    color: #fff;
    cursor: pointer;
    height: 60px;
    line-height: 60px;
    padding-left: 10px;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    .more {
      font-size: 12px;
      padding-right: 10px;
    }
  }

  .xx1_lb {
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    flex-wrap: wrap;
    li {
      width: 49%;
      padding-bottom: 0;
      height: 66px;
      margin-bottom: 0px;
      display: -webkit-flex;
      display: flex;
      -webkit-box-align: center;
      align-items: center;
    }
  }
}
</style>
